export default [
  { id: 1, 작업내용: '전기공사',
    유해위험요인: '차량에 무리하게 올라가 작업 중 운반 차량에서 \n추락',
    개선대책: '1. 전기자재 하역 중 운반차량에 무리하게 올라가지 않도록\n    관리감독',
  },
  { id: 2, 작업내용: '전기공사',
    유해위험요인: '소형 가공자재를 로프로 결속하여 인양 중 로프가 탈락하면서 자재 낙하',
    개선대책: '1. 소형 가공자재는 인양용 박스에 담아 운반',
  },
  { id: 3, 작업내용: '전기공사',
    유해위험요인: '사다리 위에서 전선 인입작업 중 추락',
    개선대책: '1. 전선 인입작업 시 작업발판으로 사다리 대신 이동식 \n    비계를 사용하도록 지도',
  },
  { id: 4, 작업내용: '전기공사',
    유해위험요인: '작업발판을 각재로 불안전하게 설치한 후 작업 중 각재가 탈락하면서 추락',
    개선대책: '1. 작업발판이 탈락되지 않도록 2개소 이상 결속하고 \n    견고한 소재 사용',
  },
  { id: 5, 작업내용: '전기공사',
    유해위험요인: '이동식 비계에서 작업 중 작업발판이 부러지면서 \n추락',
    개선대책: '1. 이동식 비계에 안전을 인증받은 작업발판 설치',
  },
  { id: 6, 작업내용: '전기공사',
    유해위험요인: '전기분전반 설치작업 중 충전부 전기 스파크에 의한 화재',
    개선대책: '1. 전기분전반 설치 중 전기 스파크에 의한 화재방지를 위해\n    인화성물질 격리, 소화기 비치',
  },
  { id: 7, 작업내용: '전기공사',
    유해위험요인: '전기차단기 점검 중 충전전류에 의한 감전',
    개선대책: '1. 전기차단기 점검 시 통전전류 차단 후 또는 충전부 방호\n    조치 후 점검 실시',
  },
  { id: 8, 작업내용: '전기공사',
    유해위험요인: '전기판넬 교체작업 중 판넬이 떨어지면서 끼임',
    개선대책: '1. 전기판넬 설치시 떨어지지 않도록 안전하게 설치',
  },
  { id: 9, 작업내용: '전기공사',
    유해위험요인: '등기구 설치작업 중 사다리에서 추락',
    개선대책: '1. 등기구 설치 시 이동식 비계 등으로 작업발판을 \n    설치한 후 작업 실시',
  },
  { id: 10, 작업내용: '전기공사',
    유해위험요인: '고압 활선작업시 활선작업용 대차없이 작업 중 감전',
    개선대책: '1. 고압 활선작업시 활선작업용 대차를 사용하여 작업 실시',
  },
  { id: 11, 작업내용: '전기공사',
    유해위험요인: '근로자 임의로 전원 연결 중 감전',
    개선대책: '1. 외부 접속기구만 사용\n' +
      '2. 이동식 전선은 끝선에 사용자 표기\n' +
      '3. 설비 정격전류에 적합단 차단기 연결',
  },
  { id: 12, 작업내용: '전기공사',
    유해위험요인: '전선이 늘어진 상태로 자재나 작업대에 걸림',
    개선대책: '1. 전선걸이대 사용\n' +
      '2. 작업 방해가 적고, 접촉 최소화할 수 있는 위치에서 작업',
  },
]
